<template>
  <div class="freightmode row m-0 justify-content-center align-items-center">
    <div class="">
      <div class="freightmode__box row m-0 mb-4"
          @click="chkFrgMode('LAND')">
        <img height="50px" :src="getIcon('LAND')">
        <div class="px-4 text-left">
          <h1>Land</h1>
          <p>Exclusive land delivery service</p>
        </div>
        <div class="col-md p-0 text-right">
          <img src="@/assets/image/icon/arrow-right.svg" alt="">
        </div>
      </div>
      <div class="freightmode__box row m-0 mb-4"
          @click="chkFrgMode('AIR')">
        <img height="50px"  :src="getIcon('AIR')">
        <div class="px-4 text-left">
          <h1>Air</h1>
          <p>Faster Shipping with Air Cargo, Air Courier Service and Breakbulk</p>
        </div>
        <div class="col-md p-0 text-right">
          <img src="@/assets/image/icon/arrow-right.svg" alt="">
        </div>
      </div>
      <div class="freightmode__box row m-0" @click="chkFrgMode('OCEAN')">
        <img height="50px" :src="getIcon('OCEAN')">
        <div class="px-4 text-left">
          <h1>Ocean</h1>
          <p>Reliable FCL, LCL, Ocean Breakbulk, Barge and LCT Service</p>
        </div>
        <div class="col-md p-0 text-right">
          <img src="@/assets/image/icon/arrow-right.svg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'freight_mode',
  data () {
    return {
      data: {}
    }
  },
  methods: {
    chkFrgMode (typeMode) {
      this.$router.push({
        name: 'RequestShipment',
        params: {step: 'type-shipment'},
        query: {mode: typeMode}
      })
    },

    getIcon (type) {
      if (type === 'LAND') {
        return require('@/assets/image/icon/cargo-land.svg')
      } else if (type === 'AIR') {
        return require('@/assets/image/icon/cargo-plane.svg')
      } else if (type === 'OCEAN') {
        return require('@/assets/image/icon/cargo-ship.svg')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestShipment/newRequestShipment/FreightMode.vue